import AOS from 'aos';

window.addEventListener("DOMContentLoaded", () => {

	// AOS
	AOS.init({ duration: 700, once: true, disable: 'mobile' });

	// Navigation — Hamburger click
	let header = document.querySelector('header');
	let firstOpen = true;
	document.getElementById('hamburger')?.addEventListener('click', function(e) {
		header.classList.toggle('mobileOpen');
		if (firstOpen) {
			header.classList.remove('mobileClose');
			firstOpen = false;
			return;
		}
		header.classList.toggle('mobileClose');
	})

	// Navigation — Style change on scroll
	window.addEventListener('scroll', function(e) {
		if (window.scrollY >= 100) {
			header.classList.add('scrolled');
			return;
		}
		header.classList.remove('scrolled');
	})

	// Navigation - Style change on scroll init when page loads
	if (window.scrollY >= 100) {
		header.classList.add('scrolled');
	} else {
		header.classList.remove('scrolled');
	}
});